import React, { useState } from 'react'
import { wtApiCall } from '../../helpers/commons/ApiWrapper'
import { RejectReasons } from './PendingProperties'

const GREEN = '#1F4D3A'
const GOLD = '#CF9A41'

const css = `
.rc-overlay { position: fixed; inset: 0; background: rgba(0,0,0,.45); z-index: 1060; display: flex; align-items: center; justify-content: center; padding: 16px; }
.rc-box { background: #fff; border-radius: 14px; width: 100%; max-width: 520px; max-height: 90vh; overflow-y: auto; padding: 20px 22px; box-shadow: 0 10px 30px rgba(0,0,0,.25); }
.rc-title { font-size: 18px; font-weight: 700; color: ${GREEN}; margin-bottom: 4px; }
.rc-sub { color: #6b7280; font-size: 13px; margin-bottom: 14px; }
.rc-picks { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 14px; }
.rc-pick { border: 1px solid #d1d5db; background: #fff; border-radius: 20px; padding: 6px 12px; font-size: 13px; cursor: pointer; }
.rc-pick.on { background: ${GOLD}; border-color: ${GOLD}; color: #fff; }
.rc-label { font-size: 13px; font-weight: 600; color: #374151; margin-bottom: 4px; }
.rc-note { width: 100%; min-height: 90px; border: 1px solid #d1d5db; border-radius: 8px; padding: 8px 10px; font-size: 14px; }
.rc-actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 16px; }
.rc-btn { border: none; border-radius: 8px; padding: 9px 16px; font-weight: 600; cursor: pointer; }
.rc-btn:disabled { opacity: .6; cursor: default; }
.rc-btn.light { background: #f3f4f6; color: #374151; }
.rc-btn.send { background: ${GOLD}; color: #fff; }
`

const labelOf = (r) => (typeof r === 'string' ? r : r.label || r.value || '')

export default function RequestChangesModal({ id, refText, onClose, onDone }) {
  const [picks, setPicks] = useState([])
  const [note, setNote] = useState('')
  const [busy, setBusy] = useState(false)

  const toggle = (t) => setPicks((x) => (x.includes(t) ? x.filter((y) => y !== t) : [...x, t]))
  const reason = [picks.join(', '), note.trim()].filter(Boolean).join(' \u2014 ')

  const send = () => {
    if (!reason) return
    setBusy(true)
    wtApiCall(
      'property/' + id,
      { action: 'reject', rejection_reason: reason },
      'PUT',
      (res) => {
        setBusy(false)
        alert(typeof res?.data === 'string' ? res.data : res?.message || 'Changes requested.')
        onDone()
      },
      (err) => {
        setBusy(false)
        alert(err?.message || 'Something went wrong')
      },
    )
  }

  return (
    <div className="rc-overlay" onClick={onClose}>
      <style>{css}</style>
      <div className="rc-box" onClick={(e) => e.stopPropagation()}>
        <div className="rc-title">Request changes{refText ? ` \u00b7 ${refText}` : ''}</div>
        <div className="rc-sub">The agent will see this feedback and can edit and resubmit the listing.</div>
        <div className="rc-picks">
          {RejectReasons.map((r) => {
            const t = labelOf(r)
            return (
              <button key={t} type="button" className={'rc-pick' + (picks.includes(t) ? ' on' : '')} onClick={() => toggle(t)}>
                {t}
              </button>
            )
          })}
        </div>
        <div className="rc-label">Note to the agent (optional)</div>
        <textarea className="rc-note" value={note} onChange={(e) => setNote(e.target.value)} spellCheck />
        <div className="rc-actions">
          <button className="rc-btn light" disabled={busy} onClick={onClose}>Cancel</button>
          <button className="rc-btn send" disabled={busy || !reason} onClick={send}>
            {busy ? 'Sending…' : 'Send to agent'}
          </button>
        </div>
      </div>
    </div>
  )
}